<!-- This Mixin is used to retrieve different kinds of json files e.g. pricing, genes, gene panels.
If the API call fails, retry the call for MAX_TRIES times behind the scene. If after MAX_TRIES, it is still 
unable to get response, display the alert message to the end user. 
 -->
<script>
import axios from "axios";
import { EventBus } from "../event-bus";

const MAX_TRIES = 2;

export default {
  methods: {
    async execRetrieveJson(endpoint) {
      let res = null;
      for (let i = 1; i <= MAX_TRIES; i++) {
        res = await this.retrieveJsonFile(endpoint);

        // If the API call has got response, exit the loop
        if (res) break;
      }

      if (!res) {
        const alert = "An error occurred, please refresh the page";

        EventBus.$emit("updateShowRetrieveAlert", alert);
        return res;
      }

      return res.data;
    },
    async retrieveJsonFile(endpoint) {
      try {
        const res = await axios.get(endpoint);
        return res;
      } catch (error) {
        console.log(`Caught error when making API call to ${endpoint}:`, error);
      }
    },
  },
};
</script>
